import { useState } from "react";
import TopBar from "@/components/app/TopBar";
import Sidebar from "@/components/app/Sidebar";
import StoriesBar from "@/components/app/StoriesBar";
import Composer from "@/components/app/Composer";
import FeedToggle from "@/components/app/FeedToggle";
import Feed from "@/components/app/Feed";
import RightRail from "@/components/app/RightRail";

export default function Home() {
  const [mode, setMode] = useState("vinculos");
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div data-testid="home-app" className="bg-cream min-h-screen text-ink">
      <TopBar />
      <div className="max-w-[1600px] mx-auto flex">
        <Sidebar activeFeed={mode} setActiveFeed={setMode} />

        <main className="flex-1 min-w-0 px-4 md:px-6 lg:px-8 py-5">
          <div className="max-w-[640px] mx-auto xl:mx-0 xl:ml-auto xl:mr-8">
            <StoriesBar />
            <Composer onPublished={() => setRefreshKey((k) => k + 1)} />
            <FeedToggle value={mode} onChange={setMode} />
            <Feed mode={mode} refreshKey={refreshKey} />
          </div>
        </main>

        <RightRail />
      </div>
    </div>
  );
}
